import moment from 'moment'
import PropTypes from 'prop-types'
import { Grid, GridColumn as Column } from '@progress/kendo-react-grid'

import { Images } from '~/assets'
import { ConvertLocalTimeGet } from '~/utils'
import { XlsxIcon, DocxIcon, PdfIcon } from '~/components'

import gridColumn from './attachment-task-checklist.column.json'

import SC from '../styled.activity'
import { CloudIcon } from '../../../../../components'

const AttachmentTaskChecklistGrid = ({ inEdit, dataGrid, location, onDelete, onDownload }) => {
  const _actionCell = (props) => {
    return (
      <td>
        <>
          <SC.ActionCellContainer>
            {inEdit && (
              <SC.PointerCell id='exct-doc-mdl-action-delete-td' onClick={() => onDelete(props.dataItem)}>
                <SC.DeleteIcon />
              </SC.PointerCell>
            )}
            {!props.dataItem.is_new && (
              <SC.PointerCell id='exct-doc-mdl-action-download-td' onClick={() => onDownload(props.dataItem)}>
                <CloudIcon />
              </SC.PointerCell>
            )}
          </SC.ActionCellContainer>
        </>
      </td>
    )
  }

  const _getFileIcon = (props) => {
    const filename = props.dataItem.filename
    const extension = filename.split('.')[filename.split('.').length - 1].toLowerCase()

    if (extension === 'doc' || extension === 'docx') {
      return <DocxIcon dataIndex={props.dataIndex} />
    }
    if (extension === 'xls' || extension === 'xlsx') {
      return <XlsxIcon dataIndex={props.dataIndex} />
    }
    if (extension === 'pdf') {
      return <PdfIcon dataIndex={props.dataIndex} />
    }
    if (extension === 'jpg' || extension === 'jpeg' || extension === 'png') {
      // eslint-disable-next-line react/no-unknown-property
      return <img src={Images.filesIconImg} dataIndex={props.dataIndex} />
    }
  }

  const _filenameCell = (props) => {
    return (
      <td style={{ display: 'flex', gap: 8, flexDirection: 'row', alignItems: 'center', height: 75 }}>
        <span style={{ marginRight: 10, fontSize: 30 }}> {_getFileIcon(props)} </span>
        {props.dataItem.is_new && (
          <p>{props.dataItem.filename}</p>
        )}
        {!props.dataItem.is_new && (
          <a href={props.dataItem.path} target='_blank' rel='noopener noreferrer'>
            {props.dataItem.filename}
          </a>
        )}
      </td>
    )
  }

  const _fileSizeCell = (props) => (
    <td>{parseInt(+props.dataItem.filesize/1000) + ' kb'}</td>
  )

  const _uploadOnCell = (props) => {
    if (props.dataItem.is_new) {
      return <td>-</td>
    }
    return (
      <td>
        {moment(ConvertLocalTimeGet(
          location,
          props.dataItem.created_date,
          'YYYY/MM/DD HH:mm'
        )).format('DD/MM/YYYY HH:mm')}
      </td>
    )
  }

  const _rowNumberCell = (props) => (
    <td>
      <p
        style={{
          display: 'flex',
          alignItems: 'center',
          flexDirection: 'row',
          justifyContent: 'center',
        }}
      >
        {props.dataIndex + 1}
      </p>
    </td>
  )

  return (
    <Grid
      id='exe-doc-mdl-all-data'
      data={dataGrid}
      total={10}
      style={{ height: inEdit ? 250 : 450 }}
    >
      {gridColumn.map((e, index) =>
        e.field === 'Action' ? (
          <Column
            key={index}
            width={e.width}
            title={e.title}
            field={e.field}
            cell={_actionCell}
          />
        ) : e.field === 'filename' ? (
          <Column
            key={index}
            width={e.width}
            title={e.title}
            field={e.field}
            cell={_filenameCell}
          />
        ) : e.field === 'filesize' ? (
          <Column
            key={index}
            width={e.width}
            title={e.title}
            field={e.field}
            cell={_fileSizeCell}
          />
        ) : e.field === 'created_date' ? (
          <Column
            key={index}
            width={e.width}
            title={e.title}
            field={e.field}
            cell={_uploadOnCell}
          />
        ) : e.field === 'No' ? (
          <Column
            key={index}
            width={e.width}
            title={e.title}
            field={e.field}
            cell={_rowNumberCell}
          />
        ) : (
          <Column key={index} title={e.title} field={e.field} width={e.width} />
        )
      )}
    </Grid>
  )
}

AttachmentTaskChecklistGrid.propTypes = {
  inEdit: PropTypes.bool.isRequired,
  dataGrid: PropTypes.array.isRequired,
  location: PropTypes.object.isRequired,
  onDelete: PropTypes.func.isRequired,
}

export default AttachmentTaskChecklistGrid